<template>
  <div class="component-wrapper">
    <div class="d-flex flex-column">
      <div v-if="loader"></div>
      <router-view v-else :key="$route.fullPath"></router-view>

      <v-bottom-navigation
        app
        class="text-uppercase white"
        style="
          box-shadow: -2px 0px 5px 2px rgba(0, 0, 0, 0.15);
          border-radius: 15px;
          z-index: 999;
        "
      >
        <v-btn v-for="(item, i) in bottomNavigation" :key="i" :to="item.path">
          <span
            class="caption"
            style="color: #0b2239"
            :style="
              item.path.includes('map') ? 'margin-top:2px' : 'margin-top:1px'
            "
            >{{ item.label }}</span
          >
          <v-img :src="item.icon" class="nav-icon" color="accent"></v-img>
        </v-btn>

        <v-btn
          v-if="currentArea.id == 2"
          :to="`/islands/area/${$route.params.area_id}/parking`"
        >
          <span class="caption" style="color: #0b2239; margin-bottom: 0.5px">{{
            $t("menu.parking")
          }}</span>
          <v-icon color="accent" size="23">mdi-parking</v-icon>
        </v-btn>

        <v-btn @click="toggle">
          <span class="caption" style="color: #0b2239; margin-top: 1px">
            {{ $t("islands.voice_button") }}
          </span>
          <v-img
            class="nav-icon"
            :src="
              sound == '1'
                ? require('@/assets/icons/volume.svg')
                : require('@/assets/icons/volume-off.svg')
            "
          ></v-img>
        </v-btn>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  async created() {
    try {
      const res = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}`
      );
      this.area = res.data.area;

      this.setCurrentArea(this.area);

      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      area: null,
      route: null,
      loader: true,
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,

      currentRoute: (state) => state.routes.currentRoute,
      currentPoi: (state) => state.pois.currentPoi,
      sound: (state) => state.base.sound,
    }),

    bottomNavigation() {
      return [
        {
          label: this.$t("islands.routes_button"),
          path: `/islands/area/${this.$route.params.area_id}/routes`,
          icon: require("@/assets/icons/routes.svg"),
        },
        {
          label: this.$t("islands.pois_button"),
          path: `/islands/area/${this.$route.params.area_id}/pois`,
          icon: require("@/assets/icons/pois.svg"),
        },

        {
          label: this.$t("islands.map_button"),
          path: `/islands/area/${this.$route.params.area_id}/map`,
          icon: require("@/assets/icons/map.svg"),
        },
      ];
    },
  },

  methods: {
    ...mapMutations(["setCurrentArea"]),
    ...mapActions(["toggleSound"]),

    toggle() {
      if (this.sound == "1") {
        this.toggleSound("0");
      } else {
        this.toggleSound("1");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn--active > .v-btn__content .v-icon {
  color: var(--v-accent-darken1) !important;
}

.nav-icon {
  height: auto !important;
  width: 21px !important;

  flex: 0 0 auto;
  fill: red !important;
  // max-width: 10px;
}

.v-item-group.v-bottom-navigation .v-btn.v-btn--active {
  background: #eee !important;
}
</style>
